import { render, staticRenderFns } from "./OrderData.vue?vue&type=template&id=3d343ee0&scoped=true"
import script from "./OrderData.vue?vue&type=script&lang=js"
export * from "./OrderData.vue?vue&type=script&lang=js"
import style0 from "./OrderData.vue?vue&type=style&index=0&id=3d343ee0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d343ee0",
  null
  
)

export default component.exports